import { ProductTypes } from './product-types';

export const SpecProductTypeDescriptions: string[] = [
  ProductTypes.Carpet,
  ProductTypes.Cushion,
  ProductTypes.Fabric,
  ProductTypes.Furniture,
  ProductTypes.Headboard,
  ProductTypes.Lining,
  ProductTypes.Sample,
  ProductTypes.Trimming,
  ProductTypes.Wallpaper,
  ProductTypes.Yarn,
];
